import React from 'react';
import { Row, Col, Card, } from 'antd';
import './CoreValues.css';

const CoreValues = ({data,title,description}) => (
  <div className="core-values-container bg-light">
    <Row gutter={16}>
      <Col xs={24} lg={8}>
        <Card 
          className="title-card bg-light" 
          bordered={false} 
          style={{ height: '100%', textAlign: 'left', boxShadow: 'none' }}
        >
          <h1 >{title}</h1>
          <h3 className="subtitle-text">{description}</h3>
        </Card>
      </Col>

      <Col xs={24} lg={16}>
        <Row gutter={[16, 16]}>
          {data?.map((value, index) => (
            <Col key={index} xs={24} md={12}>
              <Card bordered={false} hoverable className="core-value-card">
                <div className="core-value-header">
                  <div className="icon-container">{value.icon}</div>
                  <h4 className="core-value-title">{value.title}</h4>
                </div>
                <p className="core-value-description">{value.description}</p>
              </Card>
            </Col>
          ))}
        </Row>
      </Col>
    </Row>
  </div>
);

export default CoreValues;
